module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Pan_C.bb3fcda5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Melee/Item_Weapon_Pan_C.png
// module id = 253
// module chunks = 0